import { useQuery } from "@tanstack/react-query";
import { useApiClient, useHttpClient } from "../../../../lib/http";
import { ExtraItem, PropertyAri } from "./types";

export const useExtrasQuery = (propertyTicker: string) => {
  const httpClientExtras = useHttpClient("", { usePropertyHeader: true });

  return useQuery({
    queryKey: ["extras", propertyTicker],
    queryFn: async (): Promise<ExtraItem[]> => {
      return await httpClientExtras.get<ExtraItem[]>(`/v6/api/v1/${propertyTicker}/extra`);
    },
    refetchOnWindowFocus: false,
  });
};

export const usePropertyAriQuery = (
  propertyTicker: string,
  checkIn: string,
  checkOut: string,
  selectedInventoryTicker: string,
  currentInventory?: {
    configuration: {
      adult?: number;
      baby?: number;
      child?: number;
      senior?: number;
      teenager?: number;
    };
  }
) => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ["propertyAri", checkIn, checkOut, selectedInventoryTicker],
    queryFn: async (): Promise<PropertyAri> => {
      const config = currentInventory?.configuration;

      const ariBody = {
        start: checkIn,
        end: checkOut,
        seniors: config?.senior || 2,
        adults: config?.adult || 2,
        teenagers: config?.teenager || 2,
        children: config?.child || 2,
        babies: config?.baby || 2,
        deviceInfo: {
          deviceType: "DESKTOP",
        },
        locationInfo: {
          countryCode: "ES",
        },
        promoCodes: [],
      };

      return await apiClient.post(`/api/property/${propertyTicker}/es/propertyARI`, ariBody);
    },
    refetchOnWindowFocus: false,
    enabled: !!currentInventory,
  });
};
